import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  Status,
} from "../../../features/admin/dash_map_transport/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const heattransport = useSelector((state) => state.dash_map_transport);


  const [f_name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [f_name]);

  const fetch = async (page = heattransport?.current_page) => {
    await dispatch(
      GetAll({
        f_name,
        page,
        per_page: heattransport?.per_page,
      })
    );
  };

  // const deleteData = async (id) => {
  //   try {
  //     await dispatch(Delete(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  // const toggleStatus = async (id) => {
  //   try {
  //     await dispatch(Status(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  return {
    heattransport,
    f_name,
    setName,
    fetch,
    // deleteData,
    // toggleStatus,
  };
};
